/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "vakar",
        "-2": "užvakar",
        "0": "šiandien",
        "1": "rytoj",
        "2": "poryt",
        "future": {
          "few": "po {0} dienų",
          "many": "po {0} dienos",
          "one": "po {0} dienos",
          "other": "po {0} dienų"
        },
        "past": {
          "few": "prieš {0} dienas",
          "many": "prieš {0} dienos",
          "one": "prieš {0} dieną",
          "other": "prieš {0} dienų"
        }
      },
      "day-narrow": {
        "-1": "vakar",
        "-2": "užvakar",
        "0": "šiandien",
        "1": "rytoj",
        "2": "poryt",
        "future": {
          "few": "po {0} d.",
          "many": "po {0} d.",
          "one": "po {0} d.",
          "other": "po {0} d."
        },
        "past": {
          "few": "prieš {0} d.",
          "many": "prieš {0} d.",
          "one": "prieš {0} d.",
          "other": "prieš {0} d."
        }
      },
      "day-short": {
        "-1": "vakar",
        "-2": "užvakar",
        "0": "šiandien",
        "1": "rytoj",
        "2": "poryt",
        "future": {
          "few": "po {0} d.",
          "many": "po {0} d.",
          "one": "po {0} d.",
          "other": "po {0} d."
        },
        "past": {
          "few": "prieš {0} d.",
          "many": "prieš {0} d.",
          "one": "prieš {0} d.",
          "other": "prieš {0} d."
        }
      },
      "hour": {
        "0": "šią valandą",
        "future": {
          "few": "po {0} valandų",
          "many": "po {0} valandos",
          "one": "po {0} valandos",
          "other": "po {0} valandų"
        },
        "past": {
          "few": "prieš {0} valandas",
          "many": "prieš {0} valandos",
          "one": "prieš {0} valandą",
          "other": "prieš {0} valandų"
        }
      },
      "hour-narrow": {
        "0": "šią valandą",
        "future": {
          "few": "po {0} val.",
          "many": "po {0} val.",
          "one": "po {0} val.",
          "other": "po {0} val."
        },
        "past": {
          "few": "prieš {0} val.",
          "many": "prieš {0} val.",
          "one": "prieš {0} val.",
          "other": "prieš {0} val."
        }
      },
      "hour-short": {
        "0": "šią valandą",
        "future": {
          "few": "po {0} val.",
          "many": "po {0} val.",
          "one": "po {0} val.",
          "other": "po {0} val."
        },
        "past": {
          "few": "prieš {0} val.",
          "many": "prieš {0} val.",
          "one": "prieš {0} val.",
          "other": "prieš {0} val."
        }
      },
      "minute": {
        "0": "šią minutę",
        "future": {
          "few": "po {0} minučių",
          "many": "po {0} minutės",
          "one": "po {0} minutės",
          "other": "po {0} minučių"
        },
        "past": {
          "few": "prieš {0} minutes",
          "many": "prieš {0} minutės",
          "one": "prieš {0} minutę",
          "other": "prieš {0} minučių"
        }
      },
      "minute-narrow": {
        "0": "šią minutę",
        "future": {
          "few": "po {0} min.",
          "many": "po {0} min.",
          "one": "po {0} min.",
          "other": "po {0} min."
        },
        "past": {
          "few": "prieš {0} min.",
          "many": "prieš {0} min.",
          "one": "prieš {0} min.",
          "other": "prieš {0} min."
        }
      },
      "minute-short": {
        "0": "šią minutę",
        "future": {
          "few": "po {0} min.",
          "many": "po {0} min.",
          "one": "po {0} min.",
          "other": "po {0} min."
        },
        "past": {
          "few": "prieš {0} min.",
          "many": "prieš {0} min.",
          "one": "prieš {0} min.",
          "other": "prieš {0} min."
        }
      },
      "month": {
        "-1": "praėjusį mėnesį",
        "0": "šį mėnesį",
        "1": "kitą mėnesį",
        "future": {
          "few": "po {0} mėnesių",
          "many": "po {0} mėnesio",
          "one": "po {0} mėnesio",
          "other": "po {0} mėnesių"
        },
        "past": {
          "few": "prieš {0} mėnesius",
          "many": "prieš {0} mėnesio",
          "one": "prieš {0} mėnesį",
          "other": "prieš {0} mėnesių"
        }
      },
      "month-narrow": {
        "-1": "praėjusį mėnesį",
        "0": "šį mėnesį",
        "1": "kitą mėnesį",
        "future": {
          "few": "po {0} mėn.",
          "many": "po {0} mėn.",
          "one": "po {0} mėn.",
          "other": "po {0} mėn."
        },
        "past": {
          "few": "prieš {0} mėn.",
          "many": "prieš {0} mėn.",
          "one": "prieš {0} mėn.",
          "other": "prieš {0} mėn."
        }
      },
      "month-short": {
        "-1": "praėjusį mėnesį",
        "0": "šį mėnesį",
        "1": "kitą mėnesį",
        "future": {
          "few": "po {0} mėn.",
          "many": "po {0} mėn.",
          "one": "po {0} mėn.",
          "other": "po {0} mėn."
        },
        "past": {
          "few": "prieš {0} mėn.",
          "many": "prieš {0} mėn.",
          "one": "prieš {0} mėn.",
          "other": "prieš {0} mėn."
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "praėjęs ketvirtis",
        "0": "šis ketvirtis",
        "1": "kitas ketvirtis",
        "future": {
          "few": "po {0} ketvirčių",
          "many": "po {0} ketvirčio",
          "one": "po {0} ketvirčio",
          "other": "po {0} ketvirčių"
        },
        "past": {
          "few": "prieš {0} ketvirčius",
          "many": "prieš {0} ketvirčio",
          "one": "prieš {0} ketvirtį",
          "other": "prieš {0} ketvirčių"
        }
      },
      "quarter-narrow": {
        "-1": "praėjęs ketvirtis",
        "0": "šis ketvirtis",
        "1": "kitas ketvirtis",
        "future": {
          "few": "po {0} ketv.",
          "many": "po {0} ketv.",
          "one": "po {0} ketv.",
          "other": "po {0} ketv."
        },
        "past": {
          "few": "prieš {0} ketv.",
          "many": "prieš {0} ketv.",
          "one": "prieš {0} ketv.",
          "other": "prieš {0} ketv."
        }
      },
      "quarter-short": {
        "-1": "praėjęs ketvirtis",
        "0": "šis ketvirtis",
        "1": "kitas ketvirtis",
        "future": {
          "few": "po {0} ketv.",
          "many": "po {0} ketv.",
          "one": "po {0} ketv.",
          "other": "po {0} ketv."
        },
        "past": {
          "few": "prieš {0} ketv.",
          "many": "prieš {0} ketv.",
          "one": "prieš {0} ketv.",
          "other": "prieš {0} ketv."
        }
      },
      "second": {
        "0": "dabar",
        "future": {
          "few": "po {0} sekundžių",
          "many": "po {0} sekundės",
          "one": "po {0} sekundės",
          "other": "po {0} sekundžių"
        },
        "past": {
          "few": "prieš {0} sekundes",
          "many": "prieš {0} sekundės",
          "one": "prieš {0} sekundę",
          "other": "prieš {0} sekundžių"
        }
      },
      "second-narrow": {
        "0": "dabar",
        "future": {
          "few": "po {0} s",
          "many": "po {0} s",
          "one": "po {0} s",
          "other": "po {0} s"
        },
        "past": {
          "few": "prieš {0} s",
          "many": "prieš {0} s",
          "one": "prieš {0} s",
          "other": "prieš {0} s"
        }
      },
      "second-short": {
        "0": "dabar",
        "future": {
          "few": "po {0} sek.",
          "many": "po {0} sek.",
          "one": "po {0} sek.",
          "other": "po {0} sek."
        },
        "past": {
          "few": "prieš {0} sek.",
          "many": "prieš {0} sek.",
          "one": "prieš {0} sek.",
          "other": "prieš {0} sek."
        }
      },
      "week": {
        "-1": "praėjusią savaitę",
        "0": "šią savaitę",
        "1": "kitą savaitę",
        "future": {
          "few": "po {0} savaičių",
          "many": "po {0} savaitės",
          "one": "po {0} savaitės",
          "other": "po {0} savaičių"
        },
        "past": {
          "few": "prieš {0} savaites",
          "many": "prieš {0} savaitės",
          "one": "prieš {0} savaitę",
          "other": "prieš {0} savaičių"
        }
      },
      "week-narrow": {
        "-1": "praėjusią savaitę",
        "0": "šią savaitę",
        "1": "kitą savaitę",
        "future": {
          "few": "po {0} sav.",
          "many": "po {0} sav.",
          "one": "po {0} sav.",
          "other": "po {0} sav."
        },
        "past": {
          "few": "prieš {0} sav.",
          "many": "prieš {0} sav.",
          "one": "prieš {0} sav.",
          "other": "prieš {0} sav."
        }
      },
      "week-short": {
        "-1": "praėjusią savaitę",
        "0": "šią savaitę",
        "1": "kitą savaitę",
        "future": {
          "few": "po {0} sav.",
          "many": "po {0} sav.",
          "one": "po {0} sav.",
          "other": "po {0} sav."
        },
        "past": {
          "few": "prieš {0} sav.",
          "many": "prieš {0} sav.",
          "one": "prieš {0} sav.",
          "other": "prieš {0} sav."
        }
      },
      "year": {
        "-1": "praėjusiais metais",
        "0": "šiais metais",
        "1": "kitais metais",
        "future": {
          "few": "po {0} metų",
          "many": "po {0} metų",
          "one": "po {0} metų",
          "other": "po {0} metų"
        },
        "past": {
          "few": "prieš {0} metus",
          "many": "prieš {0} metų",
          "one": "prieš {0} metus",
          "other": "prieš {0} metų"
        }
      },
      "year-narrow": {
        "-1": "praėjusiais metais",
        "0": "šiais metais",
        "1": "kitais metais",
        "future": {
          "few": "po {0} m.",
          "many": "po {0} m.",
          "one": "po {0} m.",
          "other": "po {0} m."
        },
        "past": {
          "few": "prieš {0} m.",
          "many": "prieš {0} m.",
          "one": "prieš {0} m.",
          "other": "prieš {0} m."
        }
      },
      "year-short": {
        "-1": "praėjusiais metais",
        "0": "šiais metais",
        "1": "kitais metais",
        "future": {
          "few": "po {0} m.",
          "many": "po {0} m.",
          "one": "po {0} m.",
          "other": "po {0} m."
        },
        "past": {
          "few": "prieš {0} m.",
          "many": "prieš {0} m.",
          "one": "prieš {0} m.",
          "other": "prieš {0} m."
        }
      }
    },
    "locale": "lt"
  });
}